import { Component, OnInit } from '@angular/core';
import { DialogCloseResult, DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { EcounterEntryService } from '../../services/ecounter-entry.service';
import { IGetCptCodesPayload } from '../../interfaces/get-cpt-codes-payload';
import { IGetCptCodesResponse } from '../../interfaces/cpt-codes-response';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  SaveStudentCptCodeRequest,
  StudentCptCode,
} from '../../models/save-student-cpt-code-request';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-apply-cpt-codes',
  templateUrl: './apply-cpt-codes.component.html',
  styleUrls: ['./apply-cpt-codes.component.scss'],
  standalone: false,
})
export class ApplyCptCodesComponent
  extends DialogContentBase
  implements OnInit
{
  cptCodes: IGetCptCodesResponse[] = [];
  groupCptCodes: IGetCptCodesResponse[] = [];
  form: FormGroup;
  encounterSk: string | null = null; // will be set from parent
  studentSkList: string[] = [];
  serviceTypeId: number | null = null; // will be set from parent
  constructor(
    dialog: DialogRef,
    private encounterEntryService: EcounterEntryService,
    private fb: FormBuilder,
    private actiavtedRoute: ActivatedRoute,
    public loadingService: LoadingService
  ) {
    super(dialog);
    if (!this.encounterSk) {
      this.encounterSk =
        this.actiavtedRoute.snapshot.queryParamMap.get('encounterSk');
    }
  }

  ngOnInit(): void {
    this.getAllCptCodes();
  }

  initializeForm(): void {
    this.form = new FormGroup(
      Object.fromEntries(
        this.groupCptCodes.map((cpt: IGetCptCodesResponse) => [
          cpt.cptCodesMappingId,
          new FormControl(false, { nonNullable: true }),
        ])
      )
    );
  }

  get getSelectedCptCodes(): string[] {
    return Object.keys(this.form.value).filter(
      (key: string) => this.form.value[key]
    );
  }

  getAllCptCodes(): void {
    this.loadingService.show();

    const normalizedEncounterSk =
    this.encounterSk && this.encounterSk.trim().length > 0
      ? this.encounterSk
      : null;

    const payload: IGetCptCodesPayload = {
      encounterSk: normalizedEncounterSk,
      studentSk: this.studentSkList ?? [],
      serviceTypSk: this.serviceTypeId ?? 0,
    };
    this.encounterEntryService
      .getCPTCodes(payload)
      .subscribe((response: IGetCptCodesResponse[]) => {
        this.loadingService.hide();
        this.cptCodes = response;
        this.groupCptCodes = response.filter(c => c.isGroup === true);
        this.initializeForm();
      });
  }

  onSave(): void {
    const studentCptCodes: StudentCptCode[] = this.getSelectedCptCodes.map(
      (cptCode: string) => ({
        cptCodeMappingId: Number(cptCode),
        isActive: true,
      })
    );

    const payload: SaveStudentCptCodeRequest = new SaveStudentCptCodeRequest({
      encounterSk: this.encounterSk,
      studentSk: this.studentSkList,
      studentCPTCodes: studentCptCodes,
    });
    this.encounterEntryService.saveCptCode(payload).subscribe({
      next: () => {
        // close dialog and return a simple success result
        this.dialog.close({ success: true, payload });
      },
      error: () => {
        // optionally close with failure or keep dialog open
        this.dialog.close({ success: false });
      },
    });
  }

  onCancel(): void {
    this.dialog.close(new DialogCloseResult());
  }
  
}
